module.exports = __webpack_public_path__ + "img/winner-stand.314378b8.svg";